(function importImagesProcessModuleDefinition() {

    'use strict';

    angular.module('ImportImagesProcess', ['ui.router', 'Config', 'Entities', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function importImagesProcessConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('import-images-process-find', {
                    url: "/ImportImagesProcess/List",
                    templateUrl: config.resourceUrl('/views/import-images-process/list.html'),
                    controller: 'ImportImagesProcessFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('IMPORT IMAGES PROCESS READ').or('IMPORT IMAGES PROCESS WRITE')
                });

                $stateProvider.state('import-images-process-detail', {
                    url: "/ImportImagesProcess/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/import-images-process/detail.html'),
                    controller: 'ImportImagesProcessDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('IMPORT IMAGES PROCESS READ').or('IMPORT IMAGES PROCESS WRITE')
                });


                $stateProvider.state('import-images-process-add', {
                    url: "/ImportImagesProcess/Add",
                    templateUrl: config.resourceUrl('/views/import-images-process/add.html'),
                    controller: 'ImportImagesProcessAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('IMPORT IMAGES PROCESS WRITE')
                });

            }
        ]);
})();